import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useSearchResultsSelectedFilters } from '@sitecore-search/react';
import { useAccordionFacetContext } from '../../basePrimitives/AccordionFacets/index.js';
import * as RangeFacetPrimitive from '../../basePrimitives/RangeFacet/index.js';
const ACCORDION_FACET_VALUE_RANGE_NAME = 'SearchResultsAccordionFacetValueRange';
const SearchResultsFacetValueRange = React.forwardRef((props, forwardedRef) => {
    const { __scopeAccordionFacets, ...restProps } = props;
    const { facetId, onFacetItemClick } = useAccordionFacetContext(ACCORDION_FACET_VALUE_RANGE_NAME, __scopeAccordionFacets);
    const selectedFacets = useSearchResultsSelectedFilters();
    const priceFacet = selectedFacets.find((v) => v.facetId === facetId);
    const startValue = priceFacet?.min || props.min;
    const endValue = priceFacet?.max || props.max;
    const [value, setValue] = useState([startValue, endValue]);
    useEffect(() => {
        setValue([startValue, endValue]);
    }, [startValue, endValue]);
    return (_jsx(RangeFacetPrimitive.Root, { ...restProps, value: value, facetId: facetId, onFacetChange: onFacetItemClick, ref: forwardedRef }));
});
export default SearchResultsFacetValueRange;
